import { useMutation } from "@tanstack/react-query";
import useApi from "./hooks/useApi";
import { AxiosError } from "axios";

export interface WorkTypes {
  weekdays: boolean;
  weekends: boolean;
  swingShifts: boolean;
  overnights: boolean;
  dedicatedShifts: boolean;
}

export interface AvailabilityPreferences {
  days: string[];
  hours: string[];
}

export interface UserInterestPayload {
  name: string;
  phone: string;
  email: string;
  specialty: string;
  additionalInfo?: string;
  availabilityPreferences: AvailabilityPreferences;
  workTypes: WorkTypes;
  rvuPerMonth: string;
  stateLicenses: string[];
  agreeToTerms: boolean;
  hasMalpracticeInsurance: boolean | null;
}

export interface UserInterestResponse {
  message: string;
  userInterest: UserInterestPayload;
}

export interface ApiError {
  message: string;
  status: number;
}

export const useSubmitUserInterest = () => {
  const { requestFn } = useApi<UserInterestResponse>({
    url: "/user-interest",
    method: "POST",
  });

  return useMutation<UserInterestResponse, AxiosError<ApiError>, UserInterestPayload>({
    mutationFn: (data: UserInterestPayload) => requestFn(data),
  });
};

export interface ApiError {
  message: string;
  data?: {
    message: string;
  };
}
